import React from 'react';

import PropTypes from 'prop-types';

import {
    Collapse,
    FadeInOutContainer,
    FadeInOut,
} from 'wanderu-animations';
import { CaretIcon } from 'wanderu-components';
import { localize } from 'wanderu-i18n';

import FilterEvents from '../events';
import TravelMode from './TravelMode/TravelMode';

import styles from './TravelModeFilter.scss';

class TravelModeFilter extends React.Component {
    static propTypes = {
        carriers: PropTypes.object.isRequired,
        i18nMoney: PropTypes.func.isRequired,
        isTravelModesFiltered: PropTypes.bool.isRequired,
        onOnlyCarrierClick: PropTypes.func.isRequired,
        onOnlyTravelModeClick: PropTypes.func.isRequired,
        onResetTravelModes: PropTypes.func.isRequired,
        onToggleCarrier: PropTypes.func.isRequired,
        onToggleTravelMode: PropTypes.func.isRequired,
        searchParams: PropTypes.shape({
            destinationPlaceId: PropTypes.string,
            destinationText: PropTypes.string,
            originPlaceId: PropTypes.string,
            originText: PropTypes.string,
        }).isRequired,
        t: PropTypes.func.isRequired,
        totalTrips: PropTypes.number.isRequired,
        travelModes: PropTypes.arrayOf(
            PropTypes.shape({
                carriers: PropTypes.arrayOf(PropTypes.string),
                minPricing: PropTypes.arrayOf(PropTypes.object),
                state: PropTypes.oneOf([true, false, 'mixed']),
                type: PropTypes.string,
            }),
        ).isRequired,
    };

    constructor(props) {
        super(props);

        this.state = {
            isOpen: true,
        };
    }

    toggleRow = () => {
        const {
            searchParams,
        } = this.props;

        const eventFunction = this.state.isOpen
            ? FilterEvents.filterCollapsed
            : FilterEvents.filterExpanded;

        eventFunction({
            filterType: 'travel_mode',
            searchParams,
        });

        this.setState((currentState) => ({
            isOpen: !currentState.isOpen,
        }));
    };

    onResetTravelModes = () => {
        const {
            searchParams,
        } = this.props;

        FilterEvents.singleFilterReset({
            filterType: 'travel_mode_or_carriers',
            searchParams,
        });

        this.props.onResetTravelModes();
    };

    render() {
        const {
            carriers,
            i18nMoney,
            isTravelModesFiltered,
            onOnlyCarrierClick,
            onOnlyTravelModeClick,
            onToggleCarrier,
            onToggleTravelMode,
            searchParams,
            t,
            totalTrips,
            travelModes,
        } = this.props;
        const { isOpen } = this.state;

        const hasModes = travelModes.length > 0;

        return (
            <div
                className={styles.container}
            >
                <span
                    className={styles.toggleRow}
                    data-id="toggleRow"
                    onClick={this.toggleRow}
                    role="button"
                >
                    <span className={styles.title}>{t('travel-mode')}</span>

                    <CaretIcon showUpArrow={isOpen && hasModes} />
                </span>
                <Collapse
                    className={styles.collapse}
                    duration={500}
                    isOpen={isOpen && hasModes}
                >
                    {travelModes.map(({
                        type, state, carriers: carrierList, minPricing,
                    }) => {
                        let totalPrice = 0;
                        if (minPricing) {
                            totalPrice = i18nMoney(minPricing).getTotalPrice();
                        }

                        return (
                            <TravelMode
                                carrierList={carrierList}
                                carriers={carriers}
                                checkedState={state}
                                key={type}
                                onOnlyCarrierClick={onOnlyCarrierClick}
                                onOnlyTravelModeClick={onOnlyTravelModeClick}
                                onToggleCarrier={onToggleCarrier}
                                onToggleTravelMode={onToggleTravelMode}
                                searchParams={searchParams}
                                totalPrice={totalPrice}
                                totalTrips={totalTrips}
                                type={type}
                            />
                        );
                    })}
                    {hasModes && (
                        <div className={styles.resetButtonContainer}>
                            <FadeInOutContainer
                                animateHeight={false}
                                duration={250}
                            >
                                <FadeInOut show={isTravelModesFiltered}>
                                    <span
                                        className={styles.resetButton}
                                        data-id="resetButton"
                                        onClick={this.onResetTravelModes}
                                        role="button"
                                    >
                                        {t('reset')}
                                    </span>
                                </FadeInOut>
                            </FadeInOutContainer>
                        </div>
                    )}
                </Collapse>
            </div>
        );
    }
}

export { TravelModeFilter };
export default localize(TravelModeFilter, ['t', 'i18nMoney'], 'baseApp');
